import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import Grow from '@material-ui/core/Grow';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { PropTypes } from 'prop-types';

// Parametros props
//open: si se ve o no el mensaje 
//title: tipo de mensaje  {/* severity: error,  warning, info, success*/}
//msg: Mensaje a Mostrar
//CloseAlert: Cerrar el Modal

SimpleAlerts.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  msg: PropTypes.string.isRequired,
  CloseAlert: PropTypes.func.isRequired,
};

SimpleAlerts.defaultProps = {
  id: false,
  title: "info",
  msg: 'No hay mensaje',
  CloseAlert: () => { }
}

function SimpleAlerts(props) {
  var date = new Date();
  const [msg, setMsg] = React.useState(props);
  const timer = React.useRef();

  function handleStatusChange(props) {
    setMsg(props);
  }

  React.useEffect(() => {
    handleStatusChange(props);

    if (msg.title !== '') {
      timer.current = setTimeout(() => {
        props.CloseAlert();
      }, 8000);
    }

    return () => {
      clearTimeout(timer);
    };
  });

  if (msg.title !== '') {
    // Determinar el tipo de severity basado en el title
    let severity = "info"; // default
    switch (msg.title.toLowerCase()) {
      case 'success':
        severity = "success";
        break;
      case 'error':
        severity = "error";
        break;
      case 'warning':
        severity = "warning";
        break;
      case 'info':
      default:
        severity = "info";
        break;
    }

    return (
      <>
        {/* severity: error,  warning, info, success*/}
        <Grow in={props.open} style={{ transformOrigin: '0 0 0', margin: '0 auto' }} {...(props.open ? { timeout: 1200 } : {})}>
          <MuiAlert severity={severity} action={
            <IconButton aria-label="close" style={{ margin: '0 auto' }} color="inherit" size="small" onClick={() => { props.CloseAlert() }}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }>
            {" Transacción: " + date.toLocaleDateString() + " " + date.toLocaleTimeString() + ' -> ' + msg.msg}
          </MuiAlert>
        </Grow>
      </>
    );
  }
  else
    return (<></>);
}

/* retorna true si al pasar los nextProps a renderizar retorna el mismo resultado que al pasar los prevProps a renderizar, de otro modo retorna false */
function validaProps(prevProps, nextProps) {
  //si retorna un falso renderiza todo el componente, porque si es falso significa que el valor cambio
  //falso es igual que son diferentes
  //si son muchos objetos va si [0]
  return (prevProps.msg === nextProps.msg);
}

// export default SimpleAlerts;
export default React.memo(SimpleAlerts, validaProps);
